import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { Row, Col, Button } from "react-bootstrap";
import paymentSuccess from "@me-team/common/src/images/payment/payment-success.png";
import IconCreditCard from "@me-team/common/src/images/payment/icon-credit-card.svg";
import { currentBranchIdVar } from "@me-team/host/main/globalVar/state";

interface PaymentSuccessPageProps {
    paymentInvoiceUrl?: string;
}

const PaymentSuccessPage: React.FC<PaymentSuccessPageProps> = ({ paymentInvoiceUrl }) => {
    const { t } = useTranslation();
    const currentBranchId = useReactiveVar(currentBranchIdVar);

    return (
        <Row className="align-items-center text-dark py-5 bg-white">
            <Col xs={12} lg={6} className="my-auto order-2 order-lg-0">
                <div className="text-center text-lg-start mb-3 mb-lg-4">
                    <IconCreditCard width={230} height={250} className="img-fluid" />
                </div>
                <h2 className="text-capitalize fw-bold text-center text-lg-start mb-3">{t("Payment Successful!")}</h2>
                <Col xs={12} sm={10} xl={8} className="mx-auto mx-lg-0 mb-5">
                    <p className="text-grey text-center text-lg-start mb-0 me-lg-4">
                        {t("Thank you for choosing Me-Pos! The paid service is available now!")}
                    </p>
                </Col>
                <Row className="col-xxl-9">
                    <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                        <Link
                            to={`/branches/main/branch/${currentBranchId}`}
                            className="btn btn-success fs-7 text-white fw-bold rounded-1 w-100"
                        >
                            {t("Main menu")}
                        </Link>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Link
                            to={paymentInvoiceUrl}
                            className="btn btn-outline-success fs-7 text-capitalize fw-normal rounded-1 w-100 text-truncate"
                        >
                            <i className="bi bi-download me-2"></i>
                            {t("Download Receipt")}
                        </Link>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} lg={6} className="d-flex justify-content-center align-items-center py-5">
                <img
                    src={paymentSuccess}
                    width="609"
                    height="598"
                    loading="lazy"
                    className="img-fluid"
                    alt={t("Payment successful")}
                />
            </Col>
        </Row>
    );
};

export default PaymentSuccessPage;
